import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const activateDoctorApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}doctor/activate`,
        method: "put",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default activateDoctorApi